// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideShare2 as RawLucideShare2 } from "lucide-react";
export const LucideShare2 = /* @__PURE__ */ createIcon(RawLucideShare2, "LucideShare2", 2);
